import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const CHAPTERS = [
  {
    n: "I",
    t: "The Cycle of Twelve",
    b: "Once every twelve years, when Jupiter enters Leo — the sign of Simha — the Mahakumbh returns to Ujjain. It is one of four sacred cities in India that hosts this cosmic rhythm, each a resonance of an ancient story of amrit — the nectar of immortality.",
  },
  {
    n: "II",
    t: "Ujjain, the Meridian of Time",
    b: "In ancient India, Ujjain was the zero-meridian — the prime line from which time itself was measured. It sits upon the Tropic of Cancer, and its skies have held observatories, astronomers, and kings for two millennia. To arrive in Ujjain is to arrive in the geometry of time.",
  },
  {
    n: "III",
    t: "Mahakaleshwar, the Lord of Time",
    b: "At the heart of Ujjain stands the Mahakaleshwar Jyotirlinga — one of twelve most sacred manifestations of Shiva. It is the only Jyotirlinga that faces south, and its pre-dawn Bhasma Aarti — the ritual of sacred ash — is unlike anything else in the Indian sacred landscape.",
  },
  {
    n: "IV",
    t: "The Shipra",
    b: "The Shipra is the river that gathers Simhastha. To bathe in her waters on a Shahi Snan day is, by tradition, to be washed of lifetimes. The five royal baths of 2028 are the tempo of the entire Mela.",
  },
];

export default function About() {
  return (
    <div data-testid="about-page" className="pt-32 md:pt-40">
      <section className="mx-auto max-w-[1400px] px-6 md:px-12">
        <span className="overline text-primary">On the Kumbh</span>
        <h1 className="mt-6 max-w-4xl font-serif text-5xl leading-[1.02] tracking-tight md:text-8xl">
          A gathering older than <em className="italic text-primary">memory</em>.
        </h1>
        <p className="mt-10 max-w-2xl font-sans-lux text-lg leading-relaxed text-foreground/75">
          Simhastha is not a festival. It is a rhythm the subcontinent has kept for two thousand years — a rhythm of
          water and fire, of sadhus and householders, of surrender and continuity.
        </p>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 md:py-32">
        <div className="grid gap-6 md:grid-cols-3">
          {[
            "https://images.unsplash.com/photo-1627894483216-2138af692e32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxyaXZlciUyMGFhcnRpJTIwY2VyZW1vbnklMjBpbmRpYXxlbnwwfHx8fDE3ODM2MTMzNzh8MA&ixlib=rb-4.1.0&q=85",
            "https://images.unsplash.com/photo-1543934776-32d1cc654abb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBzYWRodSUyMHNwaXJpdHVhbCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MjYzNDc1OXww&ixlib=rb-4.1.0&q=85",
            "https://images.pexels.com/photos/35171273/pexels-photo-35171273.jpeg",
          ].map((src, i) => (
            <div key={i} className={`relative overflow-hidden border hairline ${i === 1 ? "md:translate-y-16" : ""}`}>
              <img src={src} alt="" className="aspect-[3/4] w-full object-cover" />
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1200px] px-6 pb-24 md:px-12 md:pb-40">
        <div className="divide-y hairline border-y hairline">
          {CHAPTERS.map((c) => (
            <div key={c.n} className="grid gap-8 py-14 md:grid-cols-12">
              <div className="md:col-span-3">
                <span className="font-serif text-5xl text-primary md:text-7xl">{c.n}</span>
              </div>
              <div className="md:col-span-9">
                <h2 className="font-serif text-3xl leading-tight md:text-5xl">{c.t}</h2>
                <p className="mt-6 max-w-2xl font-sans-lux text-lg leading-relaxed text-foreground/75">{c.b}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-24 flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <p className="max-w-xl font-serif text-2xl italic text-foreground/80 md:text-3xl">
            "In Ujjain, time itself is worshipped. To arrive is to be met."
          </p>
          <Link to="/plan-your-visit">
            <Button
              data-testid="about-cta"
              className="rounded-none bg-primary px-10 py-7 text-primary-foreground hover:bg-primary/90"
            >
              <span className="overline">Curate Your Journey</span>
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
